import React, { createContext, useContext, useState } from 'react';

const AlertContext = createContext();

export function useAlert() {
    return useContext(AlertContext);
}

export function AlertProvider({ children }) {
    const [alertMessage, setAlertMessage] = useState('');

    const showAlert = (message) => {
        setAlertMessage(message);
        setTimeout(() => setAlertMessage(''), 3000); // auto-hide after 3 seconds
    };

    return (
        <AlertContext.Provider value={{ alertMessage, showAlert }}>
            {children}
            {alertMessage && (
                <div style={{
                    position: 'fixed',
                    bottom: '20px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    backgroundColor: '#333',
                    color: '#fff',
                    padding: '10px 20px',
                    borderRadius: '5px',
                    zIndex: 9999
                }}>
                    {alertMessage}
                </div>
            )}
        </AlertContext.Provider>
    );
}
